import {InitPage} from "../index";
import {ImportFile} from "../common/import_file";

class CustomModulesBin {
  constructor() {
    InitPage("index", () => {
      let import_file = new ImportFile();
    });

    $('#link_bin_number_orders_dialog').click((e) => {
      e.preventDefault();
      $('#import-dialog').modal('show');
    })
  }
}

export function LoadPage() {
  InitPage("bin", () => {
    const bin = new CustomModulesBin();
  });
}
